export default __webpack_public_path__ + "static/mun2017-50aa6ad1a1db8c7114ec13354d97e863.jpg";